import translationEN from '../locales/en/translation.json';
import translationVI from '../locales/vi/translation.json';
import translationENGB from '../locales/en-GB/translation.json';

export const resources = {
  en: { translation: translationEN },
  vi: { translation: translationVI },
  'en-GB': { translation: translationENGB },
} as const;

export const defaultNS = 'translation';

const { translation } = resources.en;
export type TranslationKeyMap = typeof translation;
export type TranslationKey = keyof TranslationKeyMap;

export const DEFAULT_LANGUAGE = 'en';

export const XMS_LANGUAGE_KEY = 'Language';
export const DX_LANGUAGE_KEY = 'DX-Language';

export const XMS_LANGUAGE_MAP: {[key: string]: string} = {
  en: 'en_US',
  vi: 'vi_VN',
  'en-GB': 'en_US',
};

export const VIETNAMESE_LANGUAGES_CODES = [
  'vi',
  'vi-VN',
  'vi_VN',
];
